"use client";

import { Button } from "components/ui/Button";
import { ActivityButton } from "components/ui/Button/ActivityButton";
import { Card } from "components/ui/Card";
import { CardSection } from "components/ui/Card/CardSection";
import { ErrorBlock } from "components/ui/ErrorBlock";
import { H2 } from "components/ui/H";
import { Stack } from "components/ui/Stack";
import { useRouter } from "next/navigation";
import { useCallback } from "react";
import { useTotpForm } from "../hooks/useTotpForm";
import { TOTPInputField } from "./TOTPInputField";

export const TOTPFormCard = () => {
  const router = useRouter();

  const handleBackToLogin = useCallback(() => {
    router.push("/login");
  }, [router]);

  const { form, formFullFilled, errorMessage, submitStatus, handleSubmit } = useTotpForm({
    onLoginSucceeded: () => {
      router.push("/delivery_requests");
    },
  });

  const {
    register,
    formState: { errors },
  } = form;

  return (
    <div className="mr-auto ml-auto min-w-80 text-center">
      <form onSubmit={handleSubmit}>
        <Card>
          <CardSection>
            <Stack spacing="xl">
              <H2>二段階認証</H2>
              <p className="text-sm text-gray-600">
                メールに送信された6桁の認証コードを入力してください
              </p>
              {errorMessage && <ErrorBlock>{errorMessage}</ErrorBlock>}
              <TOTPInputField errors={errors} register={register} />
              <div className="flex justify-between">
                <Button onClick={handleBackToLogin}>戻る</Button>
                <ActivityButton
                  buttonTheme="primary"
                  type="submit"
                  working={submitStatus.running}
                  disabled={!formFullFilled}
                >
                  確認
                </ActivityButton>
              </div>
            </Stack>
          </CardSection>
        </Card>
      </form>
    </div>
  );
};
